import React, { FC, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ButtonTypes, IconButton } from '@eika/button';
import { Checkbox } from '@eika/checkbox';
import { IconTypes } from '@eika/icon';
import { ButtonToggles } from '@eika/radio-button';

import { ValgtWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import VerdivurderingInfoModal from './verdivurderingInfoModal';

export type OenskerVerdivurdering = {
    oenskerVerdivurdering: ValgtWeb;
    samtykke: boolean;
};

const Verdivurdering: FC = () => {
    const { verdivurdering, button, validationMessage } = useTranslation();
    const [showModal, setShowModal] = useState<boolean>(false);

    const {
        control,
        setValue,
        watch,
        formState: { errors },
    } = useFormContext<OenskerVerdivurdering>();

    return (
        <div>
            <VerdivurderingInfoModal showModal={showModal} setShowModal={setShowModal} />
            <Controller
                name="oenskerVerdivurdering"
                control={control}
                rules={{
                    validate: { ikkeValgt: (value: ValgtWeb) => value !== ValgtWeb.IKKE_VALGT },
                }}
                render={({ field: { value } }) => (
                    <ButtonToggles
                        label={verdivurdering.title}
                        data-track-id="kreditt-boliglaan-verdivurdering"
                        data-track-linkname={value}
                        onChange={(value) => setValue('oenskerVerdivurdering', value as ValgtWeb)}
                        selectedOption={value}
                        options={[
                            { label: button.ja, value: ValgtWeb.JA },
                            { label: button.nei, value: ValgtWeb.NEI },
                        ]}
                        errorMessage={
                            errors.oenskerVerdivurdering?.type === 'ikkeValgt'
                                ? `${validationMessage.requiredChoose}`
                                : ''
                        }
                        infoButton={
                            <IconButton
                                className="sgw-radio-icon"
                                icon={IconTypes.INFO_24}
                                screenReaderText={button.iconButtonInformasjon}
                                buttonType={ButtonTypes.ICON}
                                onClick={() => setShowModal(true)}
                            />
                        }
                    />
                )}
            />
            {watch('oenskerVerdivurdering') === ValgtWeb.JA && (
                <Controller
                    name="samtykke"
                    control={control}
                    rules={{
                        validate: { ikkeSamtykket: (value) => value !== false },
                    }}
                    render={({ field: { value } }) => (
                        <div style={{ marginTop: '30px' }}>
                            <Checkbox
                                onValueChange={(checked) => setValue('samtykke', checked)}
                                checked={value}
                                label={verdivurdering.samtykke.replace('{banknavn}', 'banken')}
                                error={
                                    errors.samtykke?.type === 'ikkeSamtykket' ? `${verdivurdering.samtykkeError}` : ''
                                }
                            />
                        </div>
                    )}
                />
            )}
        </div>
    );
};

export default Verdivurdering;
